import { createActionGroup, emptyProps } from '@ngrx/store';

export const UnsubscribePageActions = createActionGroup({
  source: 'Unsubscribe Page',
  events: {
    'Unsubscribe Logged In User': emptyProps(),
  },
});
